export const TOAST_SUCCESS_NOTIFY = 'TOAST_SUCCESS_NOTIFY';
export const TOAST_ERROR_NOTIFY = 'TOAST_ERROR_NOTIFY';
